import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import { StripeError, loadStripe } from '@stripe/stripe-js'
import { useEffect, useState } from 'react'
import LoadingSpinner from '../../../../components/common/LoadingSpinner'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import { s_products } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { STRIPE_PK } from '../../../../modules/vars'
import { getClientSecret } from './stripeUtils'

interface IStripeFormProps {
  paymentType: string | null
  stripeLoading: boolean
  setStripeLoading: (value: boolean) => void
  isNoRedirect?: boolean
  submitStripeForm?: boolean
  setSubmitStripeForm?: (value: boolean) => void

  returnUrl: string // 외부에서 주입되는 URL
}

export const StripeInnerForm = ({
  paymentType,
  stripeLoading,
  setStripeLoading,
  isNoRedirect = false,
  submitStripeForm,
  setSubmitStripeForm,

  returnUrl,
}: IStripeFormProps) => {
  const stripe = useStripe()
  const elements = useElements()
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    if (submitStripeForm) {
      const executeStripe = async () => {
        if (!stripe || !elements) {
          return
        }

        const params = {
          elements,
          confirmParams: {
            return_url: returnUrl,
          },
        }

        let stripeError: Partial<StripeError> = {}

        const { error } = await stripe.confirmPayment(params)
        if (error) {
          stripeError = error
        }

        if (Object.keys(stripeError).length) {
          setErrorMessage(stripeError.message || 'Unknown error occurred')
          setSubmitStripeForm(false)
        }
      }
      executeStripe()
    }
  }, [submitStripeForm])

  useEffect(() => {
    if (paymentType !== 'stripe') {
      return
    }
    setTimeout(() => {
      setStripeLoading(false)
    }, 1500)
  }, [paymentType])

  return (
    <div>
      {stripeLoading && <LoadingSpinner show={true} muted padded />}
      <PaymentElement
        id="section-stripe"
        options={{
          paymentMethodOrder: ['kr_card', 'kakao_pay', 'naver_pay', 'kr_card', 'samsung_pay', 'payco', 'card'],
        }}
      />
      {errorMessage && <div className="text-error pt-4">{errorMessage}</div>}
    </div>
  )
}

const PaymentStripeForm = ({
  payload,
  createUrl,
  errorRedirectUrl,
  clientSecretUrl,
  returnUrl,
  submitStripeForm, // boolean value for executing stripe payment
  setSubmitStripeForm, // trigger for executing stripe payment
  setStripeAmount,
  stripeLoading,
  setStripeLoading,
}) => {
  const router = useAppRouter()
  const { t } = useTranslation()
  const stripePromise = loadStripe(STRIPE_PK)

  const alertAmountText = t(s_products.purchase_must_be)
  const createPurchaseStripeErrorCallback = (id, error) => router.push(errorRedirectUrl(id, error))

  const [paymentType, setPaymentType] = useState<string>('stripe')
  const [stripeClientSecret, setStripeClientSecret] = useState<string | null>(null)

  useEffect(() => {
    if (!stripeClientSecret && paymentType === 'stripe') {
      getClientSecret(
        setStripeLoading,
        payload,
        setStripeClientSecret,
        clientSecretUrl,
        alertAmountText,
        createPurchaseStripeErrorCallback,
        createUrl,
        setStripeAmount
      )
    }
  }, [stripeClientSecret, paymentType])

  // useEffect(() => {
  //   const totalPrice = 1000
  //   if (totalPrice != stripeAmount) {
  //     setStripeClientSecret(null)
  //   }
  // }, [stripeAmount])

  console.log(stripeClientSecret, 'stripeClientSecret')
  return (
    stripeClientSecret && (
      <Elements
        stripe={stripePromise}
        options={{
          clientSecret: stripeClientSecret,
          appearance: {},
        }}
      >
        <StripeInnerForm
          paymentType={paymentType}
          stripeLoading={stripeLoading}
          setStripeLoading={setStripeLoading}
          submitStripeForm={submitStripeForm}
          setSubmitStripeForm={setSubmitStripeForm}
          returnUrl={returnUrl}
        />
      </Elements>
    )
  )
}

export default PaymentStripeForm
